export const GLOBAL_HOOK_NAMESPACE = '__TANGRAM_COMPONENTS_GLOBAL_HOOK__';